import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { MetricConfig, MetricProvider } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';
import styles from './MetricDetailsTab.module.scss';

type Props = {
  metric: MetricProvider;
  config: MetricConfig;
};

export function MetricDetailsTab( { metric, config }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <section
      className={ styles.container }
      data-deprecated={ config.is_deprecated ? 'true' : undefined }
      data-testid="metric-details-tab"
    >
      <h3 className={ styles.heading }>General Properties</h3>
      <InfoCardRow>
        <InfoCard label="Metric id" value={ metric.id } />
        <InfoCard label="Created by" value={ config.created_by ?? '—' } />
        <InfoCard label="Created" value={ formatTimestamp( config.created_at, useLocalZone ) } />
        <InfoCard label="Last Updated" value={ formatTimestamp( config.updated_at, useLocalZone ) } />
      </InfoCardRow>
    </section>
  );
}
